// export const firebaseConfig = {
//     apiKey: 'AIzaSyAjwSCpOvLPgYcFr26V3gmfwJlGb-VtWAs',
//     authDomain: 'greenupvermont-de02b.firebaseapp.com',
//     databaseURL: 'https://greenupvermont-de02b.firebaseio.com',
//     projectId: 'greenupvermont-de02b',
//     storageBucket: 'greenupvermont-de02b.appspot.com',
//     messagingSenderId: '439621369113'
// };


const ENV = "prod"; // dev, qa or prod;
const environments = { dev: "Development", qa: "QA", prod: "Production" };
const ENVS = {
    dev: {
        apiKey: "AIzaSyBUicpls4kgf0-sRbEqIJorP7Vj3CCGTSg",
        authDomain: "greenupvermont-dev.firebaseapp.com",
        databaseURL: "https://greenupvermont-dev.firebaseio.com",
        projectId: "greenupvermont-dev",
        storageBucket: "greenupvermont-dev.appspot.com",
        messagingSenderId: "447874135722",
        appId: "1:447874135722:web:a73c3840d593c0f8"
    },
    qa: {
        apiKey: "AIzaSyC6BESh8be13xYW6JU-BPV1xFV5vxZh3II",
        authDomain: "greenupvermont-qa.firebaseapp.com",
        databaseURL: "https://greenupvermont-qa.firebaseio.com",
        projectId: "greenupvermont-qa",
        storageBucket: "greenupvermont-qa.appspot.com",
        messagingSenderId: "720685599935",
        appId: "1:720685599935:web:6c42fb85b9c95a5c"
    },
    prod: {
        apiKey: "AIzaSyAjwSCpOvLPgYcFr26V3gmfwJlGb-VtWAs",
        authDomain: "greenupvermont-de02b.firebaseapp.com",
        databaseURL: "https://greenupvermont-de02b.firebaseio.com",
        projectId: "greenupvermont-de02b",
        storageBucket: "greenupvermont-de02b.appspot.com",
        messagingSenderId: "439621369113",
        appId: "1:439621369113:web:34db5b703715c583"
    }
};

const baseURLs = {
    prod: "https://us-central1-greenupvermont-de02b.cloudfunctions.net/api",
    qa: "https://us-central1-greenupvermont-qa.cloudfunctions.net/api",
    dev: "https://us-central1-greenupvermont-dev.cloudfunctions.net/api"
};

export const firebaseConfig = ENVS[ENV];
export const baseURL = baseURLs[ENV];
export const environment = environments[ENV];
